import { Button, Modal, Spin, Space } from 'antd';
import { RESPONSIVE_BREAKPOINTS } from 'constants/Global/ResponsiveLayout.const';
import styled from 'styled-components';

const CARDS_LAYOUT_QUERY = `(max-width: ${RESPONSIVE_BREAKPOINTS.table - 1}px)`;

interface STYLEDPROPS {
  isMobile?: boolean;
}

export const ModalCreateComposition = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-close {
    display: none;
  }
  .ant-modal-content {
    border-radius: 8px;
  }
  @media ${CARDS_LAYOUT_QUERY} {
    &.ant-modal {
      top: 0;
      width: 100vw !important;
      max-width: 100vw;
      margin: 0;
      padding-bottom: 0;
    }
    .ant-modal-content {
      display: flex;
      flex-direction: column;
      min-height: 100vh;
      min-height: 100dvh;
      border-radius: 0;
    }
    .ant-modal-body {
      display: flex;
      flex: 1;
      flex-direction: column;
    }
    .ant-modal-footer {
      position: sticky;
      bottom: 0;
      z-index: 3;
      padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
      background: #fff;
    }
  }
`;

export const MobileFooterTotal = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 12px;
  > p {
    margin: 0;
    color: #8c8c8c;
    font-size: 14px;
  }
  > span {
    color: #353839;
    font-size: 20px;
    font-weight: 700;
  }
`;

export const MobileFooterButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;

export const MobileFooterButton = styled(Button)`
  height: 44px;
  margin: 0 !important;
`;

export const Loader = styled(Spin)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
`;

export const ModalHeaderCreateComposition = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;

  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background-color: #f78e1e;

  span {
    color: #fff;
    font-size: 22px;
    line-height: 20px;
    font-weight: 500;
  }
  p {
    color: #fff;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;

    padding: 0;
    margin-bottom: 0;
    margin-top: 12px;
  }
  @media ${CARDS_LAYOUT_QUERY} {
    padding: 16px;
    border-radius: 0;
    span {
      font-size: 18px;
    }
  }
`;

export const ModalBodyCreateComposition = styled.div`
  .cards {
    max-height: 550px;
    width: 100%;
    overflow: auto;
  }
  @media ${CARDS_LAYOUT_QUERY} {
    flex: 1;
    background: #f5f5f5;
  }
`;

export const ModalFooterCreateComposition = styled.div<STYLEDPROPS>`
  width: 100%;
  padding: ${props => props.isMobile ? '0' : '8px 40px'};
  text-align: start;
`;

export const ModalFooterInformations = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const ModalFooterInformationText = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  margin-right: 15px;
  > p {
    text-align: start;
    margin: 0;
    margin-right: 8px;
    padding-bottom: 16px;
    margin-bottom: -3px;
    color: #8c8c8c;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
  }
  > span {
    text-align: start;
    color: #353839;
    padding-bottom: 16px;
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
  }
`;

export const ModalFooterActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const ModalFooterActionsMObile = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`;

export const ContentButtons = styled(Space)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 100%;
  margin-top: 15px;
`;
